/* Elif Transfer — Teklif Sepeti motoru + sagdan acilir drawer
 * localStorage tabanli, standart Shopify sepetinden TAMAMEN ayri.
 * - window.TeklifCart: read/add/updateQty/updateNote/remove/clear/count/openDrawer
 * - "teklif:change" event yayar
 * - Header'a teklif ikonu + rozet enjekte eder
 * - Header ikonuna (veya [data-tkd-open]) tiklaninca SAGDAN drawer acar (sayfa degismez)
 * - Drawer icinde: liste (adet +/- , cikar), bos durum, "Teklif Talebini Tamamla"
 * - ".teklif-add-btn" tiklamalarini yakalar (secili varyanti ekler)
 */
(function () {
  'use strict';
  var KEY = 'elif_teklif_cart_v1';
  var FORM_URL = '/pages/teklif-talebi';
  var SHOP_URL = '/pages/tekstil';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    emit();
  }
  function count() {
    return read().reduce(function (n, i) { return n + (parseInt(i.qty, 10) || 1); }, 0);
  }
  function add(item) {
    if (!item || !item.variantId) return;
    var items = read();
    var found = null;
    for (var i = 0; i < items.length; i++) { if (items[i].variantId === item.variantId) { found = items[i]; break; } }
    if (found) { found.qty = (parseInt(found.qty, 10) || 1) + (parseInt(item.qty, 10) || 1); }
    else { items.push(item); }
    write(items);
  }
  function updateQty(variantId, qty) {
    var items = read();
    items.forEach(function (i) { if (i.variantId === variantId) { i.qty = Math.max(1, parseInt(qty, 10) || 1); } });
    write(items);
  }
  function updateNote(variantId, note) {
    var items = read();
    items.forEach(function (i) { if (i.variantId === variantId) { i.note = note || ''; } });
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }
  function remove(variantId) {
    write(read().filter(function (i) { return i.variantId !== variantId; }));
  }
  function clear() { write([]); }

  function emit() {
    try { document.dispatchEvent(new CustomEvent('teklif:change', { detail: { items: read(), count: count() } })); } catch (e) {}
    updateBadge();
    renderDrawer();
  }

  window.TeklifCart = {
    read: read, add: add, updateQty: updateQty, updateNote: updateNote,
    remove: remove, clear: clear, count: count, openDrawer: openDrawer
  };

  function esc(x) {
    return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- Header ikonu + rozet ---------- */
  function ensureHeaderIcon() {
    if (document.querySelector('.teklif-icon')) return;
    var cart = document.querySelector('cart-icon') ||
               document.querySelector('.header-actions__cart-icon') ||
               document.querySelector('.action__cart');
    if (!cart || !cart.parentNode) return;
    /* Sepet "drawer" modundayken tema, tetikleyici butonu <cart-drawer-component>
     * ICINE koyuyor. O bilesen bir satir kutusu DEGIL; icine ikon eklenirse
     * ikonlar alt alta duser (header dagilir). Bu yuzden EN DISTAKI kabugu
     * hedefliyoruz: once cart-drawer-component, yoksa eski (page modu) yapisi. */
    var wrap = cart.closest('cart-drawer-component') ||
               cart.closest('.header-actions__action') ||
               cart.closest('a') || cart.closest('button') || cart;
    var a = document.createElement('a');
    a.href = FORM_URL; /* JS acikken drawer acilir; kapali ise forma gider */
    a.className = 'teklif-icon header-actions__action';
    a.setAttribute('aria-label', 'Teklif listen');
    a.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M8 4h8a2 2 0 0 1 2 2v14l-6-3-6 3V6a2 2 0 0 1 2-2z"/>' +
      '<path d="M12 8v5m-2.5-2.5h5"/></svg>' +
      '<span class="teklif-bubble" hidden>0</span>';
    wrap.parentNode.insertBefore(a, wrap);
    updateBadge();
  }
  function updateBadge() {
    var n = count();
    var bubbles = document.querySelectorAll('.teklif-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].textContent = n;
      if (n > 0) { bubbles[i].removeAttribute('hidden'); } else { bubbles[i].setAttribute('hidden', ''); }
    }
  }

  /* ---------- Sagdan acilir drawer ---------- */
  var drawerEl = null;
  var closeTimer = null;

  function injectDrawer() {
    if (drawerEl || document.querySelector('.tkd')) { drawerEl = document.querySelector('.tkd'); return; }
    var d = document.createElement('div');
    d.className = 'tkd';
    d.setAttribute('hidden', '');
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<div class="tkd__overlay" data-tkd-close></div>' +
      '<aside class="tkd__panel" role="dialog" aria-modal="true" aria-label="Teklif listen">' +
        '<div class="tkd__accent"></div>' +
        '<header class="tkd__head">' +
          '<span class="tkd__head-t"><span class="tkd__title">Teklif Listen</span> <span class="tkd__count">0 kalem</span></span>' +
          '<button type="button" class="tkd__x" data-tkd-close aria-label="Kapat"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</header>' +
        '<div class="tkd__body">' +
          '<div class="tkd__empty" hidden>' +
            '<div class="tkd__empty-ico"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4h8a2 2 0 0 1 2 2v14l-6-3-6 3V6a2 2 0 0 1 2-2z"/><path d="M9 9.5h6M9 13h4"/></svg></div>' +
            '<p class="tkd__empty-t">Teklif listen boş</p>' +
            '<p class="tkd__empty-s">Ürün sayfalarındaki “Teklif Listesine Ekle” butonuyla, toplu teklif almak istediğin ürünleri buraya ekleyebilirsin.</p>' +
            '<a class="tkd__cta" href="' + SHOP_URL + '">Ürünleri keşfet <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13m0 0l-5-5m5 5l-5 5"/></svg></a>' +
          '</div>' +
          '<div class="tkd__list" role="list"></div>' +
        '</div>' +
        '<footer class="tkd__foot" hidden>' +
          '<p class="tkd__note">Firma bilgileri ve baskı tipi bir sonraki adımda alınır. Ekibimiz genelde <b>1–3 saat</b> içinde döner.</p>' +
          '<a class="tkd__cta" href="' + FORM_URL + '">Teklif Talebini Tamamla <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13m0 0l-5-5m5 5l-5 5"/></svg></a>' +
          '<button type="button" class="tkd__clear">Listeyi temizle</button>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(d);
    drawerEl = d;

    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-tkd-close]')) { closeDrawer(); return; }
      if (e.target.closest('.tkd__clear')) {
        if (confirm('Teklif listesini temizlemek istediğine emin misin?')) clear();
        return;
      }
      var item = e.target.closest('.tkd__item');
      if (!item) return;
      var vid = item.getAttribute('data-vid');
      if (e.target.closest('.tkd__rm')) { remove(vid); return; }
      var step = e.target.closest('.tkd__step');
      if (step) {
        var input = item.querySelector('.tkd__qinput');
        var q = (parseInt(input.value, 10) || 1) + (step.getAttribute('data-act') === 'inc' ? 1 : -1);
        updateQty(vid, Math.max(1, q));
      }
    });
    d.addEventListener('change', function (e) {
      if (e.target.classList.contains('tkd__qinput')) {
        var item = e.target.closest('.tkd__item');
        if (item) updateQty(item.getAttribute('data-vid'), Math.max(1, parseInt(e.target.value, 10) || 1));
      }
    });

    renderDrawer();
  }

  function renderDrawer() {
    var d = drawerEl || document.querySelector('.tkd');
    if (!d) return;
    var listEl = d.querySelector('.tkd__list');
    var emptyEl = d.querySelector('.tkd__empty');
    var footEl = d.querySelector('.tkd__foot');
    var countEl = d.querySelector('.tkd__count');
    var items = read();
    countEl.textContent = items.length + ' kalem';
    if (!items.length) {
      listEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;
    listEl.innerHTML = items.map(function (i) {
      var img = i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '';
      var vt = (i.variantTitle && i.variantTitle !== 'Default Title') ? '<span class="tkd__variant">' + esc(i.variantTitle) + '</span>' : '';
      return '<div class="tkd__item" role="listitem" data-vid="' + esc(i.variantId) + '">' +
        '<a class="tkd__img" href="' + esc(i.url || '#') + '">' + img + '</a>' +
        '<div class="tkd__info">' +
          '<a class="tkd__name" href="' + esc(i.url || '#') + '">' + esc(i.title) + '</a>' + vt +
          '<span class="tkd__qty">' +
            '<button type="button" class="tkd__step" data-act="dec" aria-label="Azalt">&minus;</button>' +
            '<input class="tkd__qinput" type="number" min="1" value="' + (parseInt(i.qty, 10) || 1) + '" inputmode="numeric">' +
            '<button type="button" class="tkd__step" data-act="inc" aria-label="Arttır">+</button>' +
          '</span>' +
        '</div>' +
        '<button type="button" class="tkd__rm" aria-label="Çıkar"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '</div>';
    }).join('');
  }

  function openDrawer() {
    if (!drawerEl) injectDrawer();
    var d = drawerEl;
    if (!d) return;
    clearTimeout(closeTimer);
    renderDrawer();
    d.hidden = false;
    d.removeAttribute('hidden');
    void d.offsetWidth; /* reflow -> gecis calissin */
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tkd-lock');
  }
  function closeDrawer() {
    var d = drawerEl || document.querySelector('.tkd');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tkd-lock');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (!d.classList.contains('is-open')) { d.hidden = true; d.setAttribute('hidden', ''); }
    }, 380);
  }

  /* ---------- "Teklif Sepetine Ekle" (tekil buton bloklari) ---------- */
  function onClick(e) {
    var btn = e.target.closest ? e.target.closest('.teklif-add-btn') : null;
    if (!btn) return;
    e.preventDefault();
    var block = btn.closest('.teklif-add-block');
    if (!block) return;

    var vInput = document.querySelector('product-form-component [name="id"]') ||
                 document.querySelector('form[action*="/cart/add"] [name="id"]') ||
                 document.querySelector('[ref="variantId"]');
    var variantId = vInput ? String(vInput.value) : (block.getAttribute('data-default-variant') || '');
    if (!variantId) return;

    var map = {};
    try { map = JSON.parse(block.querySelector('.teklif-add-variants').textContent) || {}; } catch (er) {}
    var v = map[variantId] || {};

    var qInput = document.querySelector('product-form-component [name="quantity"]') ||
                 document.querySelector('[name="quantity"]');
    var qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;

    add({
      variantId: variantId,
      productId: block.getAttribute('data-product-id') || '',
      title: block.getAttribute('data-product-title') || '',
      url: block.getAttribute('data-product-url') || '',
      variantTitle: v.title || '',
      image: v.image || block.getAttribute('data-product-image') || '',
      price: (typeof v.price === 'number') ? v.price : 0,
      qty: qty
    });
    feedback(btn);
    openDrawer();
  }
  function feedback(btn) {
    if (!btn.getAttribute('data-label')) { btn.setAttribute('data-label', btn.textContent.trim()); }
    btn.classList.add('is-added');
    var label = btn.querySelector('.teklif-add-btn__label') || btn;
    var prev = label.textContent;
    label.textContent = 'Teklif listene eklendi ✓';
    setTimeout(function () {
      btn.classList.remove('is-added');
      label.textContent = btn.getAttribute('data-label') || prev;
    }, 1800);
  }

  /* ---------- Baglama ---------- */
  document.addEventListener('click', onClick);
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('.teklif-icon, [data-tkd-open]') : null;
    if (trigger) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && drawerEl && drawerEl.classList.contains('is-open')) closeDrawer();
  });

  function boot() { ensureHeaderIcon(); injectDrawer(); updateBadge(); renderDrawer(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { updateBadge(); renderDrawer(); } });
})();
